import { render, staticRenderFns } from "./VerifyUbcId.vue?vue&type=template&id=22064355&scoped=true"
import script from "./VerifyUbcId.vue?vue&type=script&lang=js"
export * from "./VerifyUbcId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22064355",
  null
  
)

export default component.exports